var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-field',{ref:"QField",attrs:{"error":_vm.hasError,"error-label":_vm._f("capitalize")(_vm.errorLabel),"label":_vm._f("capitalize")(_vm.label),"helper":_vm.helper,"label-width":12}},[_c('template',{slot:"label"},[(_vm.$slots.label)?_vm._t("label",function(){return [_vm._v(_vm._s(_vm._f("capitalize")(_vm.label))+":")]}):_vm._e()],2),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-631985ba","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/form/VField.vue
// module id = 1qeK
// module chunks = 44